import { handleActions } from "redux-actions";

export default handleActions(
  {
    PORTFOLIOS_PUBLIC_GET: {
      FULFILLED: (state, action) => ({
        portfolioNames: action.payload.portfolios,
      }),
    },
  },
  {},
  { namespace: "_" }
);
